import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { waadooIconBundle } from '@internal/plugin-waadoo-core';

/**
 * The app's icons registry (see components/ui/icons/iconBundle.tsx).
 *
 * Depuis l'étape 9c, son contenu est dans `components/ui/icons/iconBundle.tsx`
 * (le cœur) ; seule l'enveloppe reste ici : IconBundleBlueprint est réservé
 * au plugin `app`. Les entrées d'Odoo (`odoo`, `odoo-shell`,
 * `odoo-instance`) viennent du module Odoo depuis l'étape 9d
 * (`icon-bundle:app/odoo-icons`, components/odoo/module.tsx) : le registre
 * fusionne les deux.
 */
export const iconsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    IconBundleBlueprint.make({
      name: 'waadoo-icons',
      params: {
        icons: waadooIconBundle,
      },
    }),
  ],
});
